import { NotFoundPage } from './components/common/NotFoundPage';

/**
 * Options every router instance gets. A notFound() thrown by a route's loader (a deleted video, or
 * someone else's) is rendered by the router's default, not the root route's notFoundComponent, so
 * the default has to be our page too.
 */
export const routerDefaults = {
  defaultNotFoundComponent: NotFoundPage,
};
